'use client'

import { createTheme } from '@mantine/core'

const theme = createTheme({
  colors: {
    'redi-blue': [
      '#1349FF',
      '#1039cc',
      '#0D2FAA',
      '#0B2591',
      '#091C7A',
      '#071362',
      '#050B4B',
      '#030633',
      '#02032A',
      '#010221'
    ],
    'redi-green': [
      '#60CC9A',
      '#55B08D',
      '#4DAF8C',
      '#3E9A7A',
      '#2F8568',
      '#1F7056',
      '#105B44',
      '#0A4F3A',
      '#04432F',
      '#003A27',
      '#10DDA0'
    ],
    'redi-gray': [
      '#ccc',
      '#EFEFEF',
      '#E6E6E6',
      '#DEDEDE',
      '#D5D5D5',
      '#CDCDCD',
      '#C4C4C4',
      '#BCBCBC',
      '#B3B3B3',
      '#ABABAB'
    ]
  },
  components: {}
})

export default theme
